import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import store from "./store";
import "./services/api.service";
import './services/axios';
import VueAnalytics from 'vue-analytics';
import AxiosPlugin from "./plugins/axiosPlugin";


Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-161080754-1',
  router
});


//ApiService.init(process.env.VUE_APP_ROOT_API);

Vue.use(Argon,  AxiosPlugin);
let v = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

